<template>
  <div>
    
    <input v-model="price" type="text">
    <button @click="displayRazorpay">Pay Now</button>
    
  </div>
</template>

<script>
import PaymentApi from '@/services/PaymentApi'


export default {
  name: 'Payment',
  data: function(){
    return {
      user: this.$store.state.user,
      price: 0
    }
  },
  methods: {
    loadScript:function(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    },

    displayRazorpay:async function(){
      const res=await this.loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );

      if(!res) {
        this.$dialog.alert("Razorpay SDK failed to load. Are you online?")
        return;
      }

      PaymentApi.generate_rzp_order_id(this.user, {amount: 100, currency: 'INR'})
      .then(function(result){
        const { amount, id: order_id, currency }=result;

        const options={
          key: "rzp_test_7xzS4xE64OdBaM",
          amount: amount.toString(),
          currency: currency,
          name: "Bot Creator",
          description: "Topup incoming messages",
          image: "https://www.thebotcreator.com/favicon.ico",
          order_id: order_id,
          handler: function(response) {
            const data={
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
            };

            this.verifySignature(order_id, data)
          }.bind(this),
          prefill: {
            
          },
          notes: {
            user_id: this.user.id,
          },
          theme: {
            color: "#343a40",
          },
        };

        const paymentObject=new window.Razorpay(options);
        paymentObject.open();

      }.bind(this))
      .catch(function(response){
        this.$dialog.alert(response.description)
        return;
      }.bind(this))
      
    },
    
    verifySignature: function(orderCreationId, data){
      PaymentApi.verify_rzp_signature(this.user, orderCreationId, data)
      .then(function(response) {
        this.$dialog.alert(response)
      }.bind(this))
      .catch(function (response) {
        this.$dialog.alert(response.description)
      }.bind(this))
    }
  }
}
</script>

<style>

</style>